import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ProgramacionService } from 'app/main/wizard-cgo/services/programacion.service';
import {TranslateService} from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import Swal from 'sweetalert2';
import * as backInter from 'app/auth/auth-data.model';
import * as $ from 'jquery';
import * as correosPrueba from './prueba';
import { ModalInfoComponent } from "./modal-info/modal-info.component";

@Component({
  selector: 'editorEmail',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {

  @ViewChild('editorMce') editorMce: any;
  @Output() cambiaPaso: EventEmitter<number> = new EventEmitter();

  comunicacionEditor: any;
  @Input() entradaDatos: Observable<any>;

  edicion = false;
  autoValidado = false;

  datosGetCorreo: any;
  htmlOriginal: string;
  asuntoCorreo: string;
  asuntoCorreoPiloto: string;
  modoEdicion: boolean;
  pasoCompleto: boolean;
  pendienteValidacion: boolean;

  tipoCorreoTag: number;
  idiomaActual:string;
  posicionIdiomaCorreo: number;
  posicionAnteriorCorreo: number;
  idiomaSel: string;

  correosFaltantes: any;

  opciones = {
    menubar: false,
    plugins: 'print preview paste importcss searchreplace autolink save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | \
              alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | \
              forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview | \
              link codesample | ltr rtl',
    toolbar_sticky: true,
    height: 1000,
    toolbar_mode: 'sliding',
    language: 'en_US'
  };

  etiquetas = [
    //"{{link}}",
    //"{{user}}"
  ];

  idiomaElegido = '';
  idiomaPrevio = '';

  constructor(
    private programacionService: ProgramacionService,
    private dialog: MatDialog,
    private translateSrv: TranslateService
  ) { }

  ngOnInit() {
    this.cambiaIdioma();
    this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdioma(); });
    this.comunicacionEditor = this.entradaDatos.subscribe( (datos) => {
      console.log("se envio datos desde componente correos: ",datos);
      this.datosGetCorreo = datos;
      this.tipoCorreoTag = datos.tipo + 1;
      this.getStatusTemplate();
    });
    this.programacionService.getStatusProgramacionMedir(localStorage.getItem('productoID')).subscribe( (data: backInter.getStatusIndiv) => {
      if(data.estatus === 3)
        this.pasoCompleto = true;
    });
    let esperaImg = setInterval(function () {
      if($(".tox-notifications-container").length && $(".tox-statusbar__branding")){
        $(".tox-notifications-container").hide();
        $(".tox-statusbar__branding").hide();
        clearInterval(esperaImg);
      }
		}, 0);

    this.getStatusEditor();
  }

  cambiaIdioma(){
    let idioma: string;
    switch (this.translateSrv.currentLang) {
      case 'en': idioma = 'en_US'; break;
      case 'es': idioma = 'es_MX'; break;
      case 'tr': idioma = 'tr_TR'; break;
      case 'zh1': case 'zh2': idioma = 'zh_CN'; break;
    }
    this.idiomaActual = idioma;
    this.opciones.language = this.idiomaActual;
  }

  eligeIdiomaLista(idioma:any) {

    // if(!this.posicionAnteriorCorreo){
    // }
    // else{
    //
    // }
    console.log(idioma);
    if(this.idiomaPrevio == ""){
      this.idiomaPrevio = idioma;
      setTimeout(() => {
        this.eligeIdioma();
      }, 200);
    }
    else{
      if(this.modoEdicion){
        let htmlNuevo:string = this.editorMce._editor.getContent();



        // if(htmlNuevo == this.htmlOriginal){
        //   console.log("html original igual");
        // }
        // else console.log("html original diferente");
        // if(this.asuntoCorreo == this.datosGetCorreo.idiomas[this.posicionAnteriorCorreo].asunto){
        //   console.log("asunto original igual");
        // }
        // else console.log("asunto original diferente: original:",this.datosGetCorreo.idiomas[this.posicionAnteriorCorreo].asunto," mod:",this.asuntoCorreoPiloto);
        // if(this.asuntoCorreoPiloto == this.datosGetCorreo.idiomas[this.posicionAnteriorCorreo].piloto){
        //   console.log("piloto original igual");
        // }
        // else console.log("piloto original diferente: original:",this.datosGetCorreo.idiomas[this.posicionAnteriorCorreo].piloto, " mod:",this.asuntoCorreoPiloto);
        //
        // this.idiomaPrevio = idioma;

        if(htmlNuevo == this.htmlOriginal && this.asuntoCorreo == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].asunto && this.asuntoCorreoPiloto == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto){
          // this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SINCAMBIOS'),2);
          this.idiomaPrevio = idioma;
          setTimeout(() => {
            this.eligeIdioma(true);
          }, 200);
        }
        else{

          Swal.fire({
            title: this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.CAMBIOIDIOMA_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.CAMBIOIDIOMA_2'),
            icon: 'warning',
            showCancelButton: true,
reverseButtons: true,
            
            
            confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
            cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
          }).then((result) => {
            if (result.value) {
              // this.idiomaPrevio = idioma;
              // this.eligeIdioma();
              this.actualizaCorreo(true);
            }
            else{
              this.idiomaElegido = this.idiomaPrevio;
              this.posicionIdiomaCorreo = this.posicionAnteriorCorreo;
            }
          });
        }
      }
      else{
        this.idiomaPrevio = idioma;
        setTimeout(() => {
          this.eligeIdioma();
        }, 200);
      }
    }
  }

  setPosLangMail(indice:number){
    if(this.posicionAnteriorCorreo == null){
      this.posicionAnteriorCorreo = indice;
    }
    else{
      this.posicionAnteriorCorreo = this.posicionIdiomaCorreo;
    }
    this.posicionIdiomaCorreo = indice;
  }
  eligeIdioma(bypass?:boolean){
    console.log("posIdiomaCorreo:",this.posicionIdiomaCorreo);
    this.pendienteValidacion = false;
    this.colocaCorreoActual(this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].html);
    this.asuntoCorreo = this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].asunto;
    if(this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto == ""){
      this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto = this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].asunto;
      this.asuntoCorreoPiloto = this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto;
    }
    else{
      this.asuntoCorreoPiloto = this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto;
    }
    let indiceEdicion = this.correosFaltantes.correosEdicion.findIndex(item => item.tipo === this.datosGetCorreo.tipo && item.productoId == localStorage.getItem('productoID') && item.idioma == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].idioma);
    if(indiceEdicion == -1){
      let indiceFaltante = this.correosFaltantes.correosFaltantes.findIndex(item => item.tipo === this.datosGetCorreo.tipo && item.productoId == localStorage.getItem('productoID') && item.idioma == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].idioma);
      if(indiceFaltante != -1){
        this.pendienteValidacion = true;
      }
    }
    else{
      //this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.ENABLED'), 2)
    }
    if(!bypass){
      this.activarEdicion(false);
    }
    else{
      this.activarEdicion(true);
    }
  }

  getStatusEditor(){
    this.programacionService.getStatusEditorEmp(localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      console.log("respGetStatusEd:",respuesta);
      if(respuesta.message == "Success"){
        this.edicion = respuesta.edicionTemplates;
        this.autoValidado = respuesta.saltarValidado;
      }
    });
  }

  getStatusTemplate(){
    this.programacionService.statusTemplate({}).subscribe((respuesta:any) => {
      console.log("gestatusTempl:",respuesta);
      if(respuesta.message == "Success"){
        this.correosFaltantes = respuesta;
      }

      // if (respuesta.message == "Success") {
      //   respuesta.correosFaltantes.forEach(correo => {
      //     if(this.datosGetCorreo.tipo == correo.tipo && localStorage.getItem('productoID') == correo.productoId){
      //       this.pendienteValidacion = true;
      //     }
      //   });
      // }
    });
  }

  irPaso(numPaso: number){
    this.cambiaPaso.emit(numPaso);
    this.activarEdicion(false);
    this.editorMce._editor.setContent('');
    this.pendienteValidacion = false;
    this.idiomaSel = null;
    this.idiomaElegido = '';
    this.idiomaPrevio = '';
  }

  cambioEditor(e){
    console.log(e);
    console.log("var Editor:",this.editorMce);
  }

  activarEdicion(status:boolean){
    this.modoEdicion = status;
    if(this.modoEdicion){
      this.editorMce._editor.setMode("design");
      this.htmlOriginal = this.editorMce._editor.getContent();
    }
    else{
      this.editorMce._editor.setMode("readonly");
    }
  }

  verInfo(){
    const dialogRef = this.dialog.open(ModalInfoComponent, {
      width: '50%'
    });
  }

  colocaCorreoActual(html:string){
    this.editorMce._editor.setContent(html);
    this.editorMce._editor.setMode("readonly");
  }

  actualizaCorreo(bypass?:boolean){
    // console.log("getcontent:",this.editorMce._editor.getContent());
    let htmlNuevo:string = this.editorMce._editor.getContent();
    let contenidoOK = true;
    // console.log(htmlNuevo," != ",this.htmlOriginal);
    // console.log(htmlNuevo);
    // console.log(this.htmlOriginal);

    if(!bypass){
      if(htmlNuevo == this.htmlOriginal && this.asuntoCorreo == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].asunto && this.asuntoCorreoPiloto == this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto){
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SINCAMBIOS'),2);
      }
      else{
        var BreakException = {};
        try {
          this.etiquetas.forEach( (etiqueta) => {
            if(!htmlNuevo.includes(etiqueta)){
              this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SINTAG') + etiqueta,2);
              contenidoOK = false;
              throw BreakException;
            }
          });
        } catch (e) {
          if (e !== BreakException) throw e;
        };
        if(contenidoOK){
          this.guardaCorreo(htmlNuevo);
        }
      }
    }
    else{
      this.guardaCorreo(htmlNuevo,true);
    }

  }

  guardaCorreo(htmlNuevo:string, bypass?:boolean){
    let cuerpoCorreo: string;
    let docVirtual = document.implementation.createHTMLDocument("prueba");
    docVirtual.documentElement.innerHTML = htmlNuevo;
    let tabla2 = docVirtual.querySelectorAll(".webkit");
    if(tabla2 && tabla2.length > 0){
      cuerpoCorreo = tabla2[0].innerHTML;
    }
    else{
      cuerpoCorreo = htmlNuevo;
    }
    let texto = "";
    if(this.autoValidado){
      texto = this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.GUARDAR_1');
    }
    else{
      texto = this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.GUARDAR_1') + "\n\n" + this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.GUARDAR_2');
    }
    if(!bypass){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
        cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
      }).then((result) => {
        if (result.value) {
          let datos: any = {
            productoId: localStorage.getItem('productoID'),
            tipo: this.datosGetCorreo.tipo,
            html: cuerpoCorreo,
            idioma: this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].idioma,
            asunto: this.asuntoCorreo,
            piloto: this.asuntoCorreoPiloto,
            texto: 'NOTIFICACIONES.EDITOR_EMAILS.NUEVAMOD'
          };
          console.log("datosCorreoGuardar:",datos);

          this.programacionService.updateTemplate(datos).subscribe( (respuesta:any) => {
            console.log("respuestaGuardaCorreo:",respuesta);

            if(respuesta.success){
              if(this.autoValidado){
                this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SAVEOK_1'),1);
              }
              else{
                this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SAVEOK_1') + '\n\n' + this.translateSrv.instant('SHEDULE2_0.EDITOR.MODALES.SAVEOK_2'),1);
              }
              // this.activarEdicion(false);
              this.pendienteValidacion = !this.autoValidado;
              this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].html = cuerpoCorreo;
              this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].asunto = this.asuntoCorreo;
              this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].piloto = this.asuntoCorreoPiloto;
              this.htmlOriginal = this.editorMce._editor.getContent();
              this.getStatusTemplate();
            }
          });
        }
      });
    }
    else{
      let datos: any = {
        productoId: localStorage.getItem('productoID'),
        tipo: this.datosGetCorreo.tipo,
        html: cuerpoCorreo,
        // idioma: this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].idioma,
        idioma: this.idiomaPrevio,
        asunto: this.asuntoCorreo,
        piloto: this.asuntoCorreoPiloto,
        texto: 'NOTIFICACIONES.EDITOR_EMAILS.NUEVAMOD'
      };
      console.log("datosCorreoGuardar:",datos);

      this.programacionService.updateTemplate(datos).subscribe( (respuesta:any) => {
        console.log("respuestaGuardaCorreo:",respuesta);

        if(respuesta.success){
          // this.activarEdicion(false);
          // this.pendienteValidacion = !this.autoValidado;
          let idxAnt = this.datosGetCorreo.idiomas.findIndex(item => item.idioma == this.idiomaPrevio);
          this.datosGetCorreo.idiomas[idxAnt].html = cuerpoCorreo;
          this.datosGetCorreo.idiomas[idxAnt].asunto = this.asuntoCorreo;
          this.datosGetCorreo.idiomas[idxAnt].piloto = this.asuntoCorreoPiloto;
          this.idiomaPrevio = this.datosGetCorreo.idiomas[this.posicionIdiomaCorreo].idioma;
          this.htmlOriginal = this.editorMce._editor.getContent();
          this.getStatusTemplate();
          this.eligeIdioma(true);
        }
      });
    }
  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

}
